import UserSubAccountsPage from './UserSubAccountsPage';

export default UserSubAccountsPage;
